import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Dialog, DialogContent } from "../../components/ui/dialog/dialog";
import { ROUTES } from "../../routes";
import { SentenceNC } from "./sentence-nc";

export function SentenceNCDialog() {
  const navigate = useNavigate();
  const { ncNId } = useParams();

  const handleOpenChange = useCallback(
    (open: boolean) =>
      void (!open && setTimeout(() => navigate(ROUTES.HOME), 500)),
    [navigate]
  );

  const handleNavigation = useCallback(() => {
    navigate(ROUTES.HOME);
  }, [navigate]);

  return (
    <Dialog defaultOpen onOpenChange={handleOpenChange}>
      <DialogContent
        className="max-w-2xl flex min-h-[756px] max-h-full [@media(max-height:756px)]:h-full [@media(max-height:756px)]:min-h-full"
        crossClassName="hidden"
      >
        <div className="bg-header-foreground grid flex-grow h-full overflow-auto">
          <SentenceNC
            ncNId={ncNId!}
            onCancel={handleNavigation}
            onSuccess={handleNavigation}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
